import React from 'react';
import PropTypes from 'prop-types';

import SideBar from 'app/components/layout/SideBar';
import Footer from 'app/components/layout/Footer';
import NetImage from 'app/images/404.png';


export default class NotFound extends React.Component {
  static propTypes = {
    match: PropTypes.isRequired,
  };

  render(): React.ReactNode {
    return (
      <div className="dashboard-app h-100">
        <div className="wrapper">
          <SideBar {...this.props} />
          <div className="container-fluid container-content">
            <div className="row">
              <div className="col text-center">
                <img className="not-found-image" src={NetImage} alt="404" />
                <h1 className="with-margin-top">
                  We're sorry, we can't find the page you're looking for.
                </h1>
              </div>
            </div>
          </div>
          {/* <div className="push" /> */}
        </div>
        <Footer />
      </div>
    );
  }
}
404;
